import { SHOP_ORDER_REFETCH } from '../../../constants';

export function triggerOrderRefetch() {
  return (dispatch) => {
    dispatch({
      type: SHOP_ORDER_REFETCH,
      payload: {
        refetchTime: Date.now()
      }
    });
  }
}
